import React from "react";

const ReportsIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.006"
      height="22.538"
      viewBox="0 0 26.006 22.538"
    >
      <g id="db7" transform="translate(-2 -6)">
        <path
          id="Path_1159"
          data-name="Path 1159"
          d="M28.006,20.3V7.3a1.3,1.3,0,0,0-1.3-1.3H3.3A1.3,1.3,0,0,0,2,7.3v13ZM3.734,8.167A.868.868,0,0,1,4.6,7.3h20.8a.868.868,0,0,1,.867.867v9.969a.868.868,0,0,1-.867.867H4.6a.868.868,0,0,1-.867-.867ZM2,21.17V22.9a1.3,1.3,0,0,0,1.3,1.3H26.706a1.3,1.3,0,0,0,1.3-1.3V21.17Zm13,2.167a.65.65,0,1,1,.65-.65A.65.65,0,0,1,15,23.337ZM10.5,9.49a4.079,4.079,0,0,1,3.821,1.83l-3.11,1.728Zm4.222,2.6a4.108,4.108,0,0,1-4.493,5.557l1.038-3.64Zm-5.33,5.327a4.11,4.11,0,0,1,.259-7.751l.806,4.038ZM21.5,11.2H18.037a.433.433,0,1,1,0-.867H21.5a.433.433,0,1,1,0,.867Zm1.3,2.167H16.737a.433.433,0,1,1,0-.867H22.8a.433.433,0,1,1,0,.867Zm0,1.734H16.737a.433.433,0,0,1,0-.867H22.8a.433.433,0,0,1,0,.867Zm0,1.734H16.737a.433.433,0,1,1,0-.867H22.8a.433.433,0,1,1,0,.867ZM19.771,27.455a1.085,1.085,0,0,1-1.084,1.084H11.319a1.084,1.084,0,0,1,0-2.167h.289l.238-1.3H18.16l.238,1.3h.289A1.085,1.085,0,0,1,19.771,27.455Z"
          fill={fill ? fill : "#000"}
        />
      </g>
    </svg>
  );
};

export default ReportsIcon;
